module.exports = "/_next/static/images/BargeM-a43703aaff01bf2ffe24f3aabca75ecc.png";